import { Component, OnDestroy, OnInit } from '@angular/core';
import { ArhivskaKnjigaClient, IOpstaPravilaArhivskaDto } from '@kodit/core/data-api';
import { AlertService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { Subscription } from 'rxjs';
import { OpstaPravilaArhivskaFormComponent } from '../opsta-pravila-arhivska-form/opsta-pravila-arhivska-form.component';

@Component({
  selector: 'kodit-opsta-pravila-arhivska',
  templateUrl: './opsta-pravila-arhivska.component.html',
  styleUrls: ['./opsta-pravila-arhivska.component.scss'],
})
export class OpstaPravilaArhivskaComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);
  opstaPravilaDto: IOpstaPravilaArhivskaDto;
  constructor(
    private _dialogService: DynamicDialogService,
    private _alertService: AlertService,
    private _client: ArhivskaKnjigaClient
  ) {}

  ngOnInit(): void {
    this.load();
  }

  private load(): void {
    this._subs.add(
      this._client.getOpstaPravilaArhivska().subscribe(
        (result) => {
          this.opstaPravilaDto = result.data;
        },
        (error) => {
          this._subs.add(
            error.subscribe((x: string) => {
              this._alertService.addFailedMsg(x);
            })
          );
        }
      )
    );
  }

  onEdit() {
    this.dialogConfig.data = {
      model: this.opstaPravilaDto,
    };
    this.dialogConfig.header = 'Izmena opštih pravila';
    this.openDialog(this.dialogConfig);
  }

  openDialog(config: DynamicDialogConfig): void {
    const ref = this._dialogService.open(
      OpstaPravilaArhivskaFormComponent,
      config
    );

    this._subs.add(
      ref.onClose.subscribe((dto: IOpstaPravilaArhivskaDto) => {
        if (dto) {
          this.opstaPravilaDto = dto;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
